import _extends from "@babel/runtime/helpers/esm/extends";
import { Bridge } from "../../_";
import { SuperDashboardCard } from "../../SuperDashboard";
import { Components } from '@icon-park/react';
import { Progress, Typography } from 'antd';
import React from 'react';
export var ResourceTopRanking = /*#__PURE__*/React.forwardRef(function (properties, ref) {
  return /*#__PURE__*/React.createElement(SuperDashboardCard, _extends({
    ref: ref
  }, properties), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: '1 1',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, properties.datum.map(function (data) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        width: '100%',
        height: '30px',
        display: 'flex',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1,
        display: 'flex',
        gap: 8
      }
    }, /*#__PURE__*/React.createElement(Components, {
      theme: "outline"
    }), /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: function onClick() {
        return Bridge.history.push(data.keyReference);
      }
    }, /*#__PURE__*/React.createElement(Typography.Text, {
      ellipsis: true
    }, data.key))), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement(Progress, {
      percent: Number((data.value * 100).toFixed(2))
    })));
  })), properties.children);
});
ResourceTopRanking.isProCard = true;